import React, { useState } from 'react';
import './RecorridoArtemisa.scss';
import View360 from '../View360/View360';
import { useTranslation } from 'react-i18next';

const RecorridoArtemisa = () => {
  const { t } = useTranslation();
  const [idScene, setId] = useState("acceso");
  const [yaw, setyaw] = useState(50);
  const [pitch, setpitch] = useState(0);

  const handleImagen = (tipo) =>{
    const removeElement = document.getElementsByClassName("active");
    if (removeElement.length) {
      removeElement[0].classList.remove("active");
    }
    const element = document.getElementById(tipo);
    element.classList.add("active");
    if(tipo === "alberca"){
      setId("alberca");
      setyaw(50);
      setpitch(0);
    } else if(tipo === "acceso"){
      setyaw(-30);
      setpitch(0);
      setId("acceso");
    }
  }

  return(
    <div className='contenedor_recorrido_artemisa'>
      {idScene ==="acceso" && (
        <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/360/1.acceso.jpg" idScene="acceso" />
      )}
      {idScene ==="alberca" && (
        <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/Artemisa/img-360-alberca-velasur.jpg" idScene="alberca" />
      )}
      <span className='disclamer'>{t('recorridoArtemisa.disclaimer')}</span>
      <div className='options artemisa'>
        <button id="acceso" className="active" onClick={() => handleImagen("acceso")}>
          {t('recorridoArtemisa.access')}
        </button>
        <button id="alberca" onClick={() => handleImagen("alberca")}>
          {t('recorridoArtemisa.pool')}
        </button>
      </div>
    </div>
  );
}

export default RecorridoArtemisa;
